export * from './NewRehab.component';
